import { Link } from "react-router-dom/cjs/react-router-dom.min";

const BigMovieList = ( {title, lists, size} ) => {
    return ( 
        <div className="bigMovieList">
            <div className="headerWrapper">
                <h2 className="header">{ title }</h2>
                <span>Swipe<span className="material-icons-outlined">navigate_next</span></span>
            </div>
            <div className="tileSlide">
                {lists.map((movie) => (
                    <div className={size} key={movie.id}>
                        <div className="movieImgContainer">
                            <img src={'https://image.tmdb.org/t/p/w1280' + movie.poster_path} alt="" /> 
                        </div>
                        <div className="tileInfo">
                            <span className="tileTitle">{movie.title}</span>
                            <div >
                                {movie.release_date && <span className="tileYear">{movie.release_date.slice(0, 4)}</span>}
                                {movie.vote_average && <span className="tileRating"><span className="material-icons-outlined">star</span>{movie.vote_average}</span>}
                            </div>
                            
                            <Link to={'/movie/' + movie.id} className="previewBtn">Watch</Link>
                        </div>
                    </div>
                ))}
            </div>    
        </div>
     );
}

export default BigMovieList;